export default __webpack_public_path__ + "static/media/Sepp-auf-Wiese-mit-Musik.3659a9cc.png";